module.exports = __webpack_public_path__ + "static/media/group-12.2ca1c4d0.svg";